export default "__VITE_ASSET__BcCT20KQ__"